<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="getAllGroupClasses"
  >
    <template #title> لیست کلاس های گروهی </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateGroupClassDialog">
        ایجاد کلاس گروهی جدید
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="groupClassSearchCommand"
        inputLabel="جستجو بر اساس عنوان کلاس"
        inputPlaceholder="آیلتس مقدماتی"
        v-model.trim="groupClassesFilters.searchCommand"
        @enter="getAllGroupClasses"
      ></SearchInput>
    </template>
    <CustomTable
      v-if="groupClassesList"
      :pageNumber="groupClassesFilters.pageNumber"
      :count="groupClassesFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="groupClassesList"
      @changePage="changePage"
    >
      <template #actions="data">
        <BButton
          class="mr-1"
          variant="transparent"
          size="sm"
          :to="`/apps/group-class/${data.item.id}`"
        >
          <FeatherIcon icon="EditIcon" size="23" class="text-info" />
        </BButton>
        <BButton
          variant="transparent"
          size="sm"
          @click="renderDeleteGroupClassDialog(data.item)"
        >
          <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <CreateGroupClassDialog
      @refetch="getAllGroupClasses"
    ></CreateGroupClassDialog>
    <DeleteGroupClassConfirmationDialog
      :defaultGroupClass="tempSelectedGroupClass"
      @refetch="getAllGroupClasses"
    ></DeleteGroupClassConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllGroupClasses();
  },
  data() {
    return {
      isLoading: false,
      groupClassesList: null,
      totalCount: null,
      tempSelectedGroupClass: null,
      groupClassesFilters: {
        pageNumber: 1,
        count: 10,
        searchCommand: null,
      },
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "name",
          label: "عنوان کلاس",
        },
        {
          key: "duration",
          label: "مدت زمان کلاس",
          formatter: (value) => `${value} دقیقه`,
        },
        {
          key: "minUserCapacity",
          label: "حداقل تعداد شرکت کننده ها",
          formatter: (value) => `${value} نفر`,
        },
        {
          key: "maxUserCapacity",
          label: "حداکثر تعداد شرکت کننده ها",
          formatter: (value) => `${value} نفر`,
        },
        {
          key: "userBasePrice",
          label: "قیمت پایه زبان آموز",
          formatter: (value) =>
            `${Intl.NumberFormat("en-US").format(value)} تومان`,
        },
        {
          key: "masterBasePrice",
          label: "قیمت پایه استاد",
          formatter: (value) =>
            `${Intl.NumberFormat("en-US").format(value)} تومان`,
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderUpdateGroupClassDialog(selectedClass) {
      this.tempSelectedGroupClass = selectedClass;
      this.$bvModal.show("update-group-class-dialog");
    },
    renderDeleteGroupClassDialog(selectedClass) {
      this.tempSelectedGroupClass = selectedClass;
      this.$bvModal.show("delete-group-class-confirmation-dialog");
    },
    renderCreateGroupClassDialog() {
      this.$bvModal.show("create-group-class-dialog");
    },
    changePage(pageNumber) {
      this.groupClassesFilters.pageNumber = pageNumber;
      this.getAllGroupClasses();
    },
    async getAllGroupClasses() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllGroupClass = new GetAllGroupClass(_this);
        getAllGroupClass.setRequestParam(_this.groupClassesFilters);
        await getAllGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.groupClassesList = res.data.data;
            _this.totalCount = res.data.total;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    PageWrapper,
    CustomTable,
    SearchInput,
    CreateGroupClassDialog,
    DeleteGroupClassConfirmationDialog,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CreateGroupClassDialog from "@/views/components/GroupClass/CreateGroupClassDialog.vue";
import DeleteGroupClassConfirmationDialog from "@/views/components/GroupClass/DeleteGroupClassConfirmationDialog.vue";
import { BButton } from "bootstrap-vue";
import { GetAllGroupClass } from "@/libs/Api/GroupClass";
</script>
